import React from "react";
import ReportCapitalProject from "./ReportCapitalProject";

const listdata = [
  { value: "capital_exp_by_project", title: "Capital Expenditure by Project" },
];

function ExpenditureByProject() {
  return (
    <ReportCapitalProject
      type="capital_exp_by_project"
      title="Capital Expenses by Project"
      route="/reports"
      options={listdata}
    />
  );
}

export default ExpenditureByProject;
